import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

declare global {
  interface Window {
    Pusher: typeof Pusher
    Echo: Echo<'pusher'>
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  const { public: config } = useRuntimeConfig()

  const { loggedIn, token } = storeToRefs(useAuthStore())

  window.Pusher = Pusher

  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: config.pusherKey,
    wsHost:
      config.pusherHost ??
      `ws-${import.meta.env.NUXT_PUSHER_APP_CLUSTER}.pusher.com`,
    wsPort: +config.pusherPort || 80,
    wssPort: +config.pusherPort || 443,
    forceTLS: config.pusherScheme === 'https',
    enabledTransports: ['ws', 'wss'],
    encrypted: true,
    cluster: (import.meta.env.NUXT_PUSHER_APP_CLUSTER as string) || 'eu',
    channelAuthorization: {
      endpoint: `${config.baseUrl}/broadcasting/auth`,
      transport: 'ajax',
      headersProvider: () =>
        token.value ? { Authorization: `Bearer ${token.value}` } : {},
    },
  })

  // if (process.dev) Pusher.logToConsole = true

  nuxtApp.vueApp.config.globalProperties.$echo = window.Echo

  // @ts-expect-error augment later
  nuxtApp.vueApp.echo = window.Echo

  watch(
    [loggedIn, token],
    ([isLoggedIn, authToken]) => {
      if (isLoggedIn && authToken) {
        window.Echo.connect()
      } else {
        window.Echo.disconnect()
      }
    },
    { immediate: true },
  )

  return {
    provide: {
      echo: window.Echo,
    },
  }
})
